import { IEntityBase } from './entityBase';

export enum PrettyAppointmentPaymentStatus {
  'PROCESSING' = 'Registrando pagamento',
  'FAILED' = 'Falha no registro do pagamento',
  'ONGOING' = 'Pagemento em andamento',
  'WAITING' = 'Aguardando pagamento',
  'APPROVED' = 'Pagamento aprovado',
  'PENDING' = 'Processando pagamento',
  'REJECTED' = 'Pagamento rejeitado',
  'CANCELED' = 'Pagamento cancelado',
  'VALIDATING' = 'Validando pagamento',
  'PAYMENT_EXTERNAL' = 'Pago ao club',
  'PAYMENT_EXTERNAL_PENDING' = 'A ser pago no club',
  'PAYMENT_HOTEL' = 'Miscellaneous',
  'FREE' = 'Isento',
}

export type AppointmentPaymentStatus =
  | 'PROCESSING'
  | 'FAILED'
  | 'ONGOING'
  | 'WAITING'
  | 'APPROVED'
  | 'PENDING'
  | 'REJECTED'
  | 'CANCELED'
  | 'VALIDATING'
  | 'PAYMENT_EXTERNAL'
  | 'PAYMENT_EXTERNAL_PENDING'
  | 'PAYMENT_HOTEL'
  | 'FREE';

export interface IAppointmentProductBase extends IEntityBase {
  appointmentId: string;
  costCenter: string;
  description?: string;
  finishAt?: string;
  name: string;
  price: number;
  productCode: string;
  productId: string;
  productNature: string;
  productType: string;
  invoiceType: 'NF' | 'ND';
  quantity: number;
  startAt?: string;
}

export interface IAppointmentBase extends IEntityBase {
  authorizedAt?: string;
  code: number;
  description?: string;
  paymentStatus: AppointmentPaymentStatus;
  totalValue: number;
  userId: string;
  ventureId: string;
}
